import React from "react";
import Careers from "../components/career/career";
import Footer from "../components/footer";
import HeaderAny from "../components/header";
import MobileNav from "../components/header-mobile";

function CareerView() {
  return (
    <div>
      <div>
        <div className="web-only">
          <HeaderAny />
        </div>
        <div className="mobile-only">
          <MobileNav />
        </div>
      </div>
      <Careers />
      <Footer />
    </div>
  );
}

export default CareerView;
